<!-- 竖向的item -->
<template>
	<div class="columnItemBlock">
		<div class="item" @click="skipDetails(item)">
			<img :src="item.banner" alt="">
			<div>

				<span class="name line-clamp-3">{{item.name}}</span>
				<!-- <p class="company line-clamp-1" v-if="routerName=='InstrumentDetails'">{{item.writers[0].company}}</p> -->
				<!-- <div class="writerName" v-if="routerName=='InstrumentDetails'">
					<img :src="item.writers[0].photo?item.writers[0].photo:require('../assets/images/defaultHead.png')" alt="" onerror="common.imgError(1,event)">
					<span>{{item.writers[0].name}}</span>
				</div> -->
				<span class="number" v-if="routerName=='ColumnIndex'">{{item.follow_total}} 关注</span>		
			</div>
		</div>
	</div>
</template>
<script>
	export default{
		props:{
			item:Object
		},
		data(){
			return{
				routerName:'',     //路由名称
			}
		},
		mounted(){
			this.routerName=this.$route.name;
		},
		methods:{
			skipDetails(obj){
				switch(this.routerName){
					case 'InstrumentDetails':
					// this.$router.push({
					// 		path:'/exclusiveView/details',
					// 		query:{
					// 			article_id:obj.id
					// 		}
					// });
					this.skipArticleDetails(obj);
					break;	
					case 'ColumnIndex':
					if(obj.is_case){
						if(obj.is_case==4){
							window.location.href=obj.hospital_channel_url;
						}
						else{
							this.$router.push({
								path:'/column/hospital',
								query:{
									id:obj.id,
									channel_id:obj.hospital_channel_url,
									share_img:obj.share_img
								}
							});
						}
					}else{
						this.$router.push({
								path:'/column/details',
								query:{
									id:obj.id
								}
						});
					}
					break;	
					case 'CaseIndex':
					this.$router.push({
							path:'/column/details',
							query:{
								id:obj.id
							}
					});
					break;	
				}
			},
			//文章详情页面
			skipArticleDetails(obj){
				console.log(obj);
					if(obj.bind_url){
						window.location.href=obj.bind_url;
					}else{
						this.$router.push({
								path:'/exclusiveView/details',
								query:{
									article_id:obj.pivot?obj.pivot.article_id:obj.id,
								}
						})
					}
			},
		}
	}
</script>
<style lang="scss">
	.columnItemBlock{
		margin-top:10px;
		@include flex(row);
		flex-wrap: wrap;
		justify-content:space-between;
		.item{
			margin-bottom:15px;
			width:165px;
			img{
				width:100%;
				height:105px;
			}
			.name{
				font-size:12px;
				color:#090909;
				text-align: justify;
			}
			.company{
				font-size: 11px;
				color: #666666;
				letter-spacing: 0.39px;
				margin-bottom:6px;
			}
			.writerName{
				@include flex(row);
				img{
					border-radius:50%;
					width:18px;
					height:18px;
					margin-right:5px;
				}
				span{
					font-size: 11px;
					color: #666666;
					letter-spacing: 0.39px;					
				}
			}
			.number{
				font-size: 11px;
				color: #999999;
			}	
		}		
	}
</style>


// WEBPACK FOOTER //
// src/components/ColumnItemBlock.vue